// extracted by mini-css-extract-plugin
export var downArrow = "_99-0";
export var infoTooltipIcon = "_99-3";
export var label = "_99-1";
export var optionCard = "_99-4";
export var upArrow = "_99-2";